import React, {useState, useEffect} from 'react'
import TextField from './TextField'
import ReactPaginate from "react-paginate";

function CsvUploadModal(props) {
    const { CloseModal, totalAddedRecord = 0, totalSkippedRecord = 0, skippedUser, message = '', totalUpdatedRecord = 0 } = props
    const [currentPage, setCurrentPage] = useState(0)
    const [offSet, setOffSet] = useState(0)
    const [perPage, setPerPage] = useState(15)
    const [items, setItems] = useState(skippedUser)
    const [user, setUser] = useState(skippedUser)
    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = (e.selected * perPage) % skippedUser.length;
        console.log(offset,"selectedPage", selectedPage);
        setCurrentPage(selectedPage)
        setOffSet(selectedPage > 0 ? offset : 0)
    };

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = offSet + perPage;
        console.log(`Loading items from ${offSet} to ${endOffset}`);
        console.log(items,"L", items);
        items && setUser(items.slice(offSet, endOffset));
        // setPageCount(Math.ceil(items.length / perPage));
      }, [offSet, perPage,currentPage]);

    return (
        <div className="user_popup active csv_upload_data">
            <span className="popup_overlay" onClick={CloseModal}></span>
            <div className="sundance_popup_createuser box_shadow">
                <span className="closePopup pointer" onClick={CloseModal}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.899 0L5.656 4.242L1.414 0L0 1.414L4.242 5.656L0 9.898L1.414 11.312L5.656 7.07L9.899 11.312L11.313 9.898L7.071 5.656L11.313 1.414L9.899 0Z" fill="black" /> </svg>
                </span>
                <div className="bg_white">
                    <div className="p_10">
                        {message !== '' ? 
                            <div className="selection_pass text_center">
                            <label className="pass_label mb_10">{message}</label>
                        </div>
                        : <>
                            <div className="selection_pass text_center">
                                <label className="pass_label mb_10">You have successfully added {totalAddedRecord} users</label>
                                {totalUpdatedRecord > 0 && <label className="pass_label mb_10">You have successfully updated {totalUpdatedRecord} users</label>}
                            </div>
                            <div className="selection_pass text_center">
                                <span className="pass_label color_red">{totalSkippedRecord} record(s) were skipped</span>
                            </div>
                        </>}
                    </div>
                    {user && user.length > 0 ?
                        <div className="table_content bg_td_table">
                            <div className="table_wrap">
                                <table>
                                    <tr>
                                        <th>Email</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Role</th>
                                        <th>Error</th>
                                        <th>Row</th>
                                    </tr>
                                    {user.map(item =>
                                        <tr>
                                            <td>{item.email}</td>
                                            <td>{item.fname}</td>
                                            <td>{item.lname}</td>
                                            <td>{item.role === 'pressUser' ? 'Press' : item.role === 'circleGuestUser' ? 'Circle Guest' : item.role === 'generalUser' ? 'General' : item.role === 'artistUser' ? 'Artist' : item.role === 'pafUser' ? 'PAF' : item.role === 'sioUser' ? 'Industry' : ''}</td>
                                            <td>{item.error}</td>
                                            <td>{item.row}</td>
                                        </tr>
                                    )}
                                    {/* <tr>
                                    <td>christine_conell@sundance.org</td>
                                    <td>Peter First Name</td>
                                    <td>Sanchez First Name</td>
                                    <td>General First Name</td>
                                </tr> 
                                <tr>
                                    <td>christine_conell@sundance.org</td>
                                    <td>Peter First Name</td>
                                    <td>Sanchez First Name</td>
                                    <td>General First Name</td>
                                </tr> */}
                                </table>
                            </div>
                        </div>
                        : ''}
                        {user && user.length && user ? (
                            <div className="custom-pagination">
                                <ReactPaginate
                                    previousLabel={""}
                                    nextLabel={""}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={Math.ceil(skippedUser.length/15)}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={currentPage}
                                />
                            </div>
                        ) : (
                                ""
                        )}
                    <div className="field_row text_center pb_25 mb_0">
                        <button className="uppercase active" onClick={CloseModal}>OK</button>
                    </div>
                    {/* <div className="no_found text_center table_content">
                        <h5>No user found.</h5>
                        <h5>You may create a new user with that email.</h5>
                        <div className="field_row">
                            <button className="uppercase ">CREATE USER</button>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}
export default CsvUploadModal